import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { BoardDetail, ColumnDef, ColumnUpdatePayload, UUID } from "@/lib/types";

interface Vars {
  boardId: UUID;
  columnId: UUID;
  payload: ColumnUpdatePayload;
}

export function useUpdateColumn() {
  const qc = useQueryClient();
  return useMutation<ColumnDef, Error, Vars>({
    mutationFn: ({ columnId, payload }) => api.updateColumn(columnId, payload),
    onSuccess: (col, { boardId }) => {
      qc.setQueryData<BoardDetail>(queryKeys.board(boardId), (prev) =>
        prev
          ? {
              ...prev,
              columns: prev.columns.map((c) => (c.id === col.id ? { ...c, ...col } : c)),
            }
          : prev,
      );
      void qc.invalidateQueries({ queryKey: queryKeys.board(boardId) });
    },
  });
}
